import type { BundleDescriptor } from '@wix/responsive-editor-bundle-infra';
import { registerBundle } from '@wix/responsive-editor-bundle-infra';
import { A11yEditorWizardPackage } from './classic-editor-entry';

const packages = { A11yEditorWizardPackage };

export const bundleDescriptor: BundleDescriptor = {
  packages,
};

registerBundle('a11y-wizard-classic-loader', bundleDescriptor);
